import {ChangesDto} from "./changes-dto";
import {Changes} from "./changes";
import {WebdokuService} from "../web-doku/webdoku.service";
import {RBCheck, RBConvert} from "@ldw/roesberg";

export class ChangesFactory {
  static fromList(wdService: WebdokuService, dtoList: ChangesDto[]): Changes[] {
    const result: Changes[] = [];
    if (!RBCheck.isNullOrHasNoValues(dtoList)) {
      dtoList.forEach(dto => {
          const item = this.fromDTO(wdService, dto);
          result.push(item);
        }
      )
    }
    return result;
  }

  static fromDTO(wdService: WebdokuService, dto: ChangesDto): Changes {
    const ch = new Changes();
    ch.id = dto.id;
    ch.text = dto.text;
    ch.date = RBConvert.jsonUTCStringToString(dto.date);
    ch.path = dto.path;
    ch.computer = dto.computer;
    ch.documentId = dto.documentID;
    ch.info = dto.info;
    ch.isNew = dto.isNew;
    ch.project = dto.project;
    ch.user = dto.user;
    ch.status = dto.status;
    if (dto.docStatusID != null) {
      const status = wdService.currentStatusValues.find(p => p.id == dto.docStatusID);
      if (status != undefined) {
        ch.docStatus = status.clone();
      }
    }
    return ch;
  }
}
